export var GroupGenderType;
(function (GroupGenderType) {
    GroupGenderType["Mixed"] = "Mixed";
    GroupGenderType["OnlyMale"] = "OnlyMale";
    GroupGenderType["OnlyFemale"] = "OnlyFemale";
})(GroupGenderType || (GroupGenderType = {}));
//# sourceMappingURL=GroupGenderType.js.map